import { t } from "i18next";
import React from "react";

import { Button } from "@src/components/ui-components/Buttons/Button/Button";
import { PopupContainer } from "@src/components/deprecated/PopupContainer/PopupContainer";
import { Text } from "@src/components/deprecated/Text/Text";
import { DateRangePicker } from "../../../../components/deprecated/DateRangePicker/DateRangePicker";

interface SelectDatePopUpProps {
  id: string;
  continue: (startDate: Date | undefined, endDate: Date | undefined) => void;
}

export const SelectDatePopUp = (props: SelectDatePopUpProps) => {
  const [deleteStartDate, setDeleteStartDate] = React.useState(new Date() as Date | null);
  const [deleteEndDate, setDeleteEndDate] = React.useState(new Date() as Date | null);

  return (
    <PopupContainer id={props.id} style={{ padding: "32px" }} centered>
      <Text size="xl" isBold marginBottom={32}>
        {t("main.deleteRoutineTasksInTimeFrame")}
      </Text>
      <DateRangePicker
        startDate={deleteStartDate}
        setStartDate={(date) => setDeleteStartDate(date)}
        endDate={deleteEndDate}
        setEndDate={(date) => setDeleteEndDate(date)}
      />
      <Button onClick={() => props.continue(deleteStartDate ?? undefined, deleteEndDate ?? undefined)} fullWidth marginTop={32}>
        {t("main.continue")}
      </Button>
    </PopupContainer>
  );
};
